'use client';

import { Omit } from 'lodash';
import { type ForwardRefExoticComponent, type RefAttributes } from 'react';

export const SelectServiceBox = ({
  selected,
  onSelect,
  title,
  description,
  icon,
  disabled,
}: {
  selected?: boolean;
  disabled?: boolean;
  title: string;
  onSelect?: () => void;
  description?: string;
  icon?: ForwardRefExoticComponent<
    Omit<RefAttributes<SVGSVGElement> & { className?: string }, 'ref'> &
      RefAttributes<any>
  >;
}) => {
  const Icon = icon;
  return (
    <div
      data-state={selected == true ? 'true' : 'false'}
      data-disabled={disabled == true}
      onClick={() => {
        if (onSelect && !disabled) {
          onSelect();
        }
      }}
      className='flex cursor-pointer items-center justify-start gap-4 overflow-hidden rounded-lg border p-4 ring-primary ring-offset-2 transition duration-150 hover:bg-muted data-[disabled=true]:cursor-not-allowed data-[disabled=true]:opacity-50 data-[state=true]:ring'
    >
      {Icon && <Icon className='h-6 w-6'></Icon>}
      <div className='flex flex-col items-start'>
        <span className='text-left text-sm font-medium'>{title}</span>
        {description && (
          <p className='text-left text-xs text-muted-foreground'>
            {description}
          </p>
        )}
      </div>
    </div>
  );
};
